/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../magnolia/lib/MagnoliaPropertyHelper';

export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface imageLinkStruct {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
}
export interface itemsStruct {
  image: Asset;
  alt ? : string;
  imageTitle ? : string;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  imageLink ? : Array < imageLinkStruct > ;
  backgroundColor ? : number;
}
export default interface Tiles {
  title ? : string;
  titleColor ? : number;
  subTitle ? : string;
  subtitleColor ? : number;
  disableShadow ? : boolean;
  items ? : Array < itemsStruct > ;
  imageLoadType ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  title: String,
  titleColor: Number,
  subTitle: String,
  subtitleColor: Number,
  disableShadow: Boolean,
  items: Array as() => Array < itemsStruct > ,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  title: String,
  titleColor: Number,
  subTitle: String,
  subtitleColor: Number,
  disableShadow: Boolean,
  items: Object,
  imageLoadType: String,
  dataABId: String,
  metadata: Object,
}

export class TilesBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class TilesInstance implements Tiles {
      title ? : string;
      titleColor ? : number;
      subTitle ? : string;
      subtitleColor ? : number;
      disableShadow ? : boolean;
      items ? : Array < itemsStruct > ;
      imageLoadType ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.items) {
          this.items = Object.entries(this.items)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'items' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.items.length; i1++) {
            if (this.items[i1]) {
              if (typeof this.items[i1].image === 'object') {
                this.items[i1].image = {
                  ...this.items[i1].image,
                  link: this.items[i1].image['@link'],
                  name: this.items[i1].image['@name'],
                  path: this.items[i1].image['@path'],
                };
              } else {
                this.items[i1].image = null as any;
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].mobileAspectRatio) {
                this.items[i1].mobileAspectRatio = Object.entries(this.items[i1].mobileAspectRatio)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
              } else {
                this.items[i1].mobileAspectRatio = null as any;
              }
            }
            if (this.items[i1]) {
              if (this.items[i1].imageLink) {
                this.items[i1].imageLink = Object.entries(this.items[i1].imageLink)
                  .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'imageLink' + '[0123456789]+')))
                  .map((pair: [string, any]) => ({
                    ...pair[1]
                  }));
                for (let i2 = 0; i2 < this.items[i1].imageLink.length; i2++) {

                  if (this.items[i1]) {
                    if (this.items[i1].imageLink[i2]) {
                      if (this.items[i1].imageLink[i2].switchable) {
                        if (typeof this.items[i1].imageLink[i2].switchable.download === 'object') {
                          this.items[i1].imageLink[i2].switchable.download = {
                            ...this.items[i1].imageLink[i2].switchable.download,
                            link: this.items[i1].imageLink[i2].switchable.download['@link'],
                            name: this.items[i1].imageLink[i2].switchable.download['@name'],
                            path: this.items[i1].imageLink[i2].switchable.download['@path'],
                          };
                        } else {
                          this.items[i1].imageLink[i2].switchable.download = null as any;
                        }
                      }
                    }
                  }
                }
              } else {
                this.items[i1].imageLink = null as any;
              }
            }
          }
        } else {
          this.items = null as any;
        }
      }
    }
    return new TilesInstance(props);
  }
}
